import React, { useMemo} from "react";
import styled from 'styled-components'
import Table from "./Table";


const TimezoneTable = (props) => {

   // table styles.  Taken from an example.  Investigate porting to css.  Produces warnings.

    const Wrapper = styled.section`
        padding: 0em;
        padding-top: 0rem;
        padding-bottom: 0rem;
        background: white;
        text-align: left;
        align-items: center;
        alignItems: center;
    `;
    const Styles = styled.div`
        padding: 1rem;

        .table {
          display: inline-block;
          border-spacing: 0;
          border: 1px solid #ccc;;

          .tr {
            :last-child {
              .td {
                border-bottom: 1px solid #ccc;
              }
            }
          }

          .th {
            margin: 0;
            padding: .5rem;
            border-bottom: 1px solid #ccc;
            border-right: 1px solid #ccc;
            color:  #00447c;
            font-weight: 600;

            :last-child {
              border-right: 1px solid #ccc;;
            }
          }


          .td {
            margin: 0;
            padding: .5rem;
            border-bottom: 1px solid #ccc;
            border-right: 1px solid #ccc;
            white-space: nowrap;
            text-overflow:ellipsis;
            overflow: hidden;

            :last-child {
              border-right: 1px solid #ccc;;
            }
          }
        }
      `

  // simple array to map columns

  const columns = useMemo(
    () => [
      {
        Header: () => (
            <span style={{display: "none"}} ></span>
        ),
        id: 'someId',
        columns: [
          {
            Header: "Timezone",
            accessor: "timezone_value",
            width: 266,
          },
          {
            Header: "Zoom Timezone",
            accessor: "zoom_timezone",
            width: 301,
          },
          {
            Header: "Current Offset",
            accessor: "timezone_offset",
            width: 200,
          },
          {
            Header: "Daylight Savings Offset",
            accessor: "dst_offset",
            width: 200,
          },
          {
            Header: "Standard Time Offset",
            accessor: "st_offset",
            width: 200,
          },
        ]
      },
    ],
    []
  );
  return (
      <Wrapper>
        <Styles>
            <Table
              columns={columns}
              data={props.data}
              caller={props.caller}
              setRefresh={props.setRefresh}
              refresh={props.refresh}
               />
        </Styles>
    </Wrapper>
  );
}

export default TimezoneTable;